import { render } from "./HouseResources.vue?vue&type=template&id=4ec01e3f&scoped=true"
import script from "./HouseResources.vue?vue&type=script&lang=js"
export * from "./HouseResources.vue?vue&type=script&lang=js"

import "./HouseResources.vue?vue&type=style&index=0&id=4ec01e3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec01e3f"]])

export default __exports__